import React from 'react';
import Header from '../start-page/Header';
import BrandAnalytics from './BrandAnalytics';
import VersionControl from './VersionControl';
import Creativity from './Creativity';
import Approval from './Approval';
import CTA from './CTA';
import Footer from '../start-page/Footer';
import CtaSection from '../start-page/CtaSection';
import styles from './SolutionPage.module.css';
import HeroSection from './HeroSection';

const SolutionPage: React.FC = () => {
    return (
        <div className={styles.container}>
            <Header />
            <HeroSection />
            <BrandAnalytics />
            <VersionControl />
            <Creativity />
            <Approval />

            <CtaSection />
            <Footer />
        </div>
    );
};

export default SolutionPage;
